// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function button44_mouseIn(event) {
	$w("#slideshow1").changeSlide(1);//Add your code for this event here: 
}

export function button45_mouseIn(event) {
	$w("#slideshow1").changeSlide(2);//Add your code for this event here: 
}

export function button46_mouseIn(event) {
	$w("#slideshow1").changeSlide(3);//Add your code for this event here: 
}

export function button47_mouseIn(event) {
	$w("#slideshow1").changeSlide(4);
	//$w("#button47").label.html = "<b>Bold Text</b>";
}
